import { STATIC_OBS_URL } from '../../consts'

import type { PageContent } from '..'

export const productsList: PageContent[] = [
  {
    id: '126.html',
    tag: '',
    name: 'GCKontrol',
    time: '',
    title: '系统设计与仿真软件',
    descriptions:
      'GCKontrol系统设计与仿真软件，是一款图形化建模仿真工具，已通过ISO26262认证(ASIL-D级)。能够实现系统设计与仿真，具备丰富的控制系统建模元素，支持控制系统建模仿真、线性非线性系统建模仿真、能自动生成高效高质量的C代码，支持FMU导出、实时仿真、自动化测试和验证。',
    thumbnail: `${STATIC_OBS_URL}/website/home/products/gck.jpeg`,
    bannerimg: ''
  },
  {
    id: '125.html',
    tag: '',
    name: 'GCAir',
    time: '',
    title: '系统仿真测试验证一体化平台',
    descriptions:
      'GCAir系统仿真测试验证一体化平台，基于MBSE(Model-Based Systems Engineering)思想，完全自主研发的一款工业软件，为复杂装备系统研制的正向设计提供了工具支撑，为数字孪生技术落地提供了解决方案，可以实现全虚拟仿真到半实物仿真。GCAir支持多源异构模型集成，从全虚拟仿真到半实物仿真的一键切换，能够在同一平台上完成模型在环、软件在环、硬件在环仿真及测试，具备连续综合集成测试验证的能力，可应用于复杂装备从设计研发到运行维护的全生命周期。',
    thumbnail: `${STATIC_OBS_URL}/website/home/products/gcair.jpeg`,
    bannerimg: ''
  },

  // {
  //   id: '124.html',
  //   tag: '',
  //   name: 'GCSys',
  //   time: '',
  //   title: '',
  //   descriptions:
  //     'GCSys是由世冠团队基于地理信息系统和可视化技术研发的集战场地理信息环境仿真于一体的综合化平台。可进行作战推演、装备论证等领域的仿真实践。具有模型构建、作想定部署、态势显示、数据监控等功能，为用户打造装备级+小体系的一站式解决方案。',
  //   thumbnail: `${STATIC_OBS_URL}/website/home/products/sys.jpeg`,
  //   bannerimg: ''
  // },
  {
    id: '123.html',
    tag: '',
    name: '实时仿真系统',
    time: '',
    title: '',
    descriptions:
      '实时仿真系统由深度定制的强实时Linux操作系统与高性能仿真引擎双核驱动。操作系统基于成熟实时库打造，为仿真引擎提供高确定性、超低延时的内核级调度接口；仿真引擎则依托操作系统API，实现关键任务的最高优先级处理，精准保障模型定时、高效解算与I/O快速响应，引擎更集成多线程智能分配与模型执行顺序可配置功能，智能均衡负载，优化时序，全面提升半实物仿真（HIL）的实时性与确定性。',
    thumbnail: `${STATIC_OBS_URL}/website/home/products/now.jpeg`,
    bannerimg: ''
  }
]
